import { render, staticRenderFns } from "./viewModal.vue?vue&type=template&id=52f25426&scoped=true&"
import script from "./viewModal.vue?vue&type=script&lang=js&"
export * from "./viewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f25426",
  null
  
)

export default component.exports